const ShippingMethods = (() => {
  let svc = {
    filterByIOShipOptions: (methods, options) => {
      let items = [];
      methods.forEach(method => {
        if (options === "ship" && method.type !== "WillCall") {
          items.push(method);
        } else if (
          options === "miami" &&
          method.type === "WillCall" &&
          method.location === "Unicity Miami Store"
        ) {
          items.push(method);
        }
      });
      return items;
    }
  };

  return {
    filterByIOShipOptions: (shippingMethods, ioShipOptions) => {
      shippingMethods.items = svc.filterByIOShipOptions(
        shippingMethods.items,
        ioShipOptions
      );
      return shippingMethods;
    }
  };
})();
export default ShippingMethods;



// WEBPACK FOOTER //
// ./src/services/shippingmethods.js